require('./cmCheckbox.scss');

const PropTypes = require('prop-types');

const React = require('react');
const classNames = require('classnames');

class CmCheckbox extends React.Component {
    render() {
        const {
            idName,
            label,
            value,
            onChange,
            disabled,
            errorState,
            errorMessage,
            instructionsMessage,
        } = this.props;

        const message = errorState ? errorMessage : instructionsMessage;
        const className = classNames('cm-checkbox', {
            'cm-checkbox--error': errorState,
        });
        const messageId = `text_${idName}`;
        let messageElement;

        if (message) {
            messageElement = (
                <span id={messageId} className="cm-checkbox__message">
                    {message}
                </span>
            );
        }

        return (
            <div className={className}>
                <input
                    id={idName}
                    type="checkbox"
                    disabled={disabled}
                    checked={value}
                    onChange={onChange}
                />
                <label className="cm-checkbox__label" htmlFor={idName}>
                    {label}
                </label>
                {messageElement}
            </div>
        );
    }
}

CmCheckbox.propTypes = {
    idName: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    label: PropTypes.any,
    value: PropTypes.bool,
    onChange: PropTypes.func,
    errorState: PropTypes.bool,
    errorMessage: PropTypes.string,
    instructionsMessage: PropTypes.string,
};

CmCheckbox.defaultProps = {
    disabled: false,
};

module.exports = CmCheckbox;
